import { useQueryApi } from "api/hooks";
import { balanceApi } from "api/TenantSlug/Balance/api";

import GetBalanceRequest = App.Http.Requests.Balance.GetBalanceRequest;
import GetBalancesRequest = App.Http.Requests.Balance.GetBalancesRequest;
import GetBalanceTotalsRequest = App.Http.Requests.Balance.GetBalanceTotalsRequest;
import GetBalanceResponse = App.Http.Responses.Balance.GetBalanceResponse;
import GetBalancesResponse = App.Http.Responses.Balance.GetBalancesResponse;
import GetBalanceTotalsResponse = App.Http.Responses.Balance.GetBalanceTotalsResponse;
import GetBalanceWalletResponse = App.Http.Responses.Balance.GetBalanceWalletResponse;

// Query to get a list of balances
export const useGetBalancesQuery = (request: GetBalancesRequest, options = {}) => {
    return useQueryApi<GetBalancesResponse>({
        queryKey: ["getBalances", request],
        queryFn: () => balanceApi.index(request),
        ...options,
    });
};

// Query to get a specific balance by ID
export const useGetBalanceQuery = (balanceId: string, request: GetBalanceRequest, options = {}) => {
    return useQueryApi<GetBalanceResponse>({
        queryKey: ["getBalance", balanceId],
        queryFn: () => balanceApi.show(balanceId, request),
        ...options,
    });
};

// Query to get the wallet summary for the header
export const useGetBalanceWalletQuery = (options = {}) => {
    return useQueryApi<GetBalanceWalletResponse>({
        queryKey: ["getBalanceWallet"],
        queryFn: () => balanceApi.wallet(),
        staleTime: 0, // Always refetch — balance must reflect payout approvals immediately, no stale caching
        refetchOnWindowFocus: true,
        ...options,
    });
};

// Query to get totals for a role, broken down per currency
export const useGetBalanceTotalsQuery = (request: GetBalanceTotalsRequest, options = {}) => {
    return useQueryApi<GetBalanceTotalsResponse>({
        queryKey: ["getBalanceTotals", request],
        queryFn: () => balanceApi.totals(request),
        staleTime: 0, // Always refetch — balance must reflect payout approvals immediately, no stale caching
        refetchOnWindowFocus: true,
        ...options,
    });
};
